module.exports = __webpack_public_path__ + "img/survey-empty.af3e587e.png";